import React from "react";
import "./FoodCalorieDatabase.css";

export default function FoodCalorieDatabase() {
  const foodData = [
    { name: "Apple", calories: 52, protein: "0.3g", fat: "0.2g", carbs: "14g" },
    { name: "Chicken Breast", calories: 165, protein: "31g", fat: "3.6g", carbs: "0g" },
    { name: "Salmon", calories: 206, protein: "22g", fat: "13g", carbs: "0g" },
    { name: "Brown Rice", calories: 123, protein: "2.6g", fat: "0.9g", carbs: "25.6g" },
    { name: "Broccoli", calories: 55, protein: "3.7g", fat: "0.6g", carbs: "11.2g" },
    { name: "Almonds", calories: 579, protein: "21g", fat: "49g", carbs: "22g" },
    { name: "Sweet Potato", calories: 86, protein: "1.6g", fat: "0.1g", carbs: "20g" },
    { name: "Egg", calories: 68, protein: "6g", fat: "5g", carbs: "0.6g" },
    { name: "Tofu", calories: 144, protein: "15.7g", fat: "8g", carbs: "3.9g" },
    { name: "Quinoa", calories: 120, protein: "4.1g", fat: "1.9g", carbs: "21.3g" },
  ];

  return (
    <div className="food-calorie-database">
      <table>
        <thead>
          <tr>
            <th>Food</th>
            <th>Calories (kcal)</th>
            <th>Protein</th>
            <th>Fat</th>
            <th>Carbohydrates</th>
          </tr>
        </thead>
        <tbody>
          {foodData.map((food, index) => (
            <tr key={index}>
              <td>{food.name}</td>
              <td>{food.calories}</td>
              <td>{food.protein}</td>
              <td>{food.fat}</td>
              <td>{food.carbs}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
